import { render } from "./PayPanel.vue?vue&type=template&id=65d73642"
import script from "./PayPanel.vue?vue&type=script&lang=js"
export * from "./PayPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__